<template>
  <div class="tab-pane active">
    <ul class="catalog__tab-list" style="margin-top: -14.5px;">
      <filter-block
          title="Бренд"
          :type="type"
          filter-key="brand"
          :force-shown="true"
          :loading="loading" />
      <filter-block
        title="Активити"
        :type="type"
        filter-key="activity"
        :force-shown="true"
        :loading="loading"
        :isCategorized="true" />
      <filter-block
        title="Коллекция"
        hint="COS1"
        :type="type"
        filter-key="collection"
        :force-shown="true"
        :loading="loading"
        :isCategorized="true" />
      <filter-block
        title="Линейка"
        hint="COS2"
        :type="type"
        filter-key="line"
        :loading="loading"
        :isCategorized="true" />
      <filter-block
        title="Сублинейка"
        hint="COS3"
        :type="type"
        filter-key="subline"
        :loading="loading"
        :isCategorized="true" />
    </ul>
  </div>
</template>

<script>
import FilterTypeCommon from '@/components/FilterTypeCommon'

export default {
  name: 'filter-type-rate',
  extends: FilterTypeCommon,
  computed: {
    type () {
      return 'rate'
    },
    api () {
      return this.$api.filter.rate()
    }
  }
}
</script>
